module.exports = __webpack_public_path__ + "img/things-logo.3d9f16f6.jpg";